import { Injectable } from '@angular/core';
import { StorageService } from '../auth/storage.service';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';
import { IProject, Project } from '../models/models.lib';
import { IEnvVars, ISettings, Settings, appDefaults } from '../common/obj.lib';
import { LoggerService } from '../shared/logger.service';

const { apiUrl } = environment;

const SETTINGS = 'settings';

@Injectable({
  providedIn: 'root'
})
export class SettingsService {
  // pollingPeriod = +import.meta.env['POLLING_PERIODS'] || 60000;

  private _settings: BehaviorSubject<Settings | undefined> = new BehaviorSubject<Settings | undefined>(undefined);
  get settings() {
    return this._settings.getValue();
  }
  set settings(val: Settings | undefined) {
    this._settings.next(val);
  }
  // settings: Settings | undefined = undefined;

  private _defaultSettings: BehaviorSubject<Settings | undefined> = new BehaviorSubject<Settings | undefined>(undefined);
  get defaultSettings() {
    return this._defaultSettings.getValue();
  }
  set defaultSettings(val: Settings | undefined) {
    this._defaultSettings.next(val);
  }

  private _version: BehaviorSubject<string> = new BehaviorSubject<string>('');
  get version() {
    return this._version.getValue();
  }
  set version(val: string) {
    this._version.next(val);
  }

  constructor(
    private logger: LoggerService,
    private storage: StorageService
  ) {
    // this.logger.log(`SettingsService...`);
  }

  get apiUrl(): string | undefined {
    // this.logger.debug(`get apiUrl: `, this.settings?.apiUrl);
    return this.settings?.apiUrl;
  }
  set apiUrl(val: string) {
    let tmp = this.getSettings();
    tmp.apiUrl = val;
    this.saveSettings(tmp);
  }

  get currentProject(): IProject | undefined {
    return this.settings?.currentProject;
  }

  set currentProject(val: IProject | undefined) {
    let tmp = this.getSettings();
    tmp.currentProject = val;
    this.saveSettings(tmp);
    // this.settings = tmp;
  }

  get appDir(): string | undefined {
    return this.settings?.app_last_directory;
  }
  set appDir(val: string) {
    let tmp = this.getSettings();
    tmp.app_last_directory = val;
    this.saveSettings(tmp);
    // this.settings = tmp;
  }
  get dbUser() {
    return this.settings?.dbUser;
  }
  get dbPw() {
    return this.settings?.dbUserPw;
  }
  get tunnelUserPw() {
    return this.settings?.tunnelUserPw;
  }
  get tunnelDbUsername() {
    return this.settings?.tunnelDbUsername;
  }
  get tunnelDbPw() {
    return this.settings?.tunnelDbPw;
  }

  get lastLogin(): string {
    if (this.settings && this.settings.lastEmail) {
      return this.settings?.lastEmail;
    }
    return '';
  }
  set lastLogin(val: string) {
    let tmp = this.getSettings();
    tmp.lastEmail = val;
    this.saveSettings(tmp);
  }

  saveSettings(settings: ISettings) {
    this.settings = settings;
    this.storage.setJson(SETTINGS, this.settings);
  }

  getSettings(): Settings {
    return this.storage.getJson(SETTINGS);
  }

  setTheSettings(overrideCurrent: boolean = false): void {
    // this.logger.debug('SettingsService:setTheSettings...', overrideCurrent);
    if (!overrideCurrent && this.storage.exists(SETTINGS)) {
      this.settings = this.storage.getJson(SETTINGS);
    } else {
      if (this.defaultSettings) {
        this.settings = Settings.initialise(this.defaultSettings.apiUrl)
        this.storage.setJson(SETTINGS, this.settings)
      }
    }
    // this.logger.debug(`setTheSettings: `, JSON.stringify(this.settings));
  }

  setDefaults() {
    // this.logger.debug(`setDefaults:defaults: `, apiUrl);
    this.defaultSettings = Settings.initialise(apiUrl);
    // this.logger.debug(`setDefaults:defaultSettings: `, JSON.stringify(this.defaultSettings));
  }

  initialize() {
    // this.version = defaults.version;
    this.setDefaults();
    this.setTheSettings(true);
  }
}
